<template>
  <div v-if="render">
    <component :is="'script'">
      <!--      var _paq = window._paq = window._paq || []; _paq.push(['setUserId', '{{-->
      <!--        user_id-->
      <!--      }}']);-->
    </component>
  </div>
</template>
<script>
export default {
  name: "TMatomoTagManager",
  props: {
    render: {
      type: Boolean,
      default: true,
    },
    userId: {
      type: String,
      default: "",
    },
  },
  computed: {
    user_id() {
      return this.userId !== "" ? this.userId : "";
    },
  },
};
</script>
